import { create } from 'zustand';

import { ARTIST_PAGE_SIZE, type ArtistOrderKey } from './artists';

export type ArtistStatusFilter = 'all' | 'active' | 'archived';

interface ArtistsQueryState {
  search: string;
  order: ArtistOrderKey;
  status: ArtistStatusFilter;
  page: number;
  pageSize: number;
  setSearch: (search: string) => void;
  setOrder: (order: ArtistOrderKey) => void;
  setStatus: (status: ArtistStatusFilter) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<ArtistsQueryState, 'search' | 'order' | 'status' | 'page' | 'pageSize'> = {
  search: '',
  order: 'newest',
  status: 'all',
  page: 1,
  pageSize: ARTIST_PAGE_SIZE,
};

export const useArtistsStore = create<ArtistsQueryState>((set) => ({
  ...defaults,

  setSearch: (search) => set({ search, page: 1 }),
  setOrder: (order) => set({ order, page: 1 }),
  setStatus: (status) => set({ status, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
